module.exports = __webpack_public_path__ + "media/images/img-secondcarrier-5-01a44ffc.jpg";